<template>
  <div
    class="card mb-25 border-0 rounded-0 bg-white text-center error-404-card radius-7"
  >
    <div class="card-body letter-spacing style-terms-area">
      
      <h1>Política de Privacidade</h1>

      <h6 class="text-terms">Esta Política de Privacidade descreve como coletamos, usamos e protegemos as informações dos usuários do nosso sistema de armazenamento de gravações de telefonia em nuvem.</h6>

      <h4>1. Dados Coletados</h4>
      <p class="text-terms">Coletamos informações como nome da empresa, nome do cliente, celular, cpf/cnpj, e-mail, números de telefone, gravações. Também podemos coletar dados técnicos, como endereço IP, dispositivo de origem da gravação para garantir a segurança do sistema e também os dados da gravação como: duração da gravação, formato, tamanho, nome original. lembrando que também temos a responsabilidade de oferecer nossos serviços somente para clientes que estão com o seu CPF/CNPJ regulamentado conforme as leis do nosso País, por este motivo ao se cadastrar, a Sanvault realiza uma consulta para validar se está tudo correto com o documento do cliente, nesta etapa buscamos informações sobre o CPF/CNPJ como também nome, endereço e informações fiscais.</p>

      <h4>2. Uso dos Dados</h4>
      <p class="text-terms">Usamos os dados para oferecer e melhorar o serviço, como organizar, armazenar e facilitar o acesso às gravações. As informações também podem ser usadas para atendimento ao cliente, comunicação com os usuários, e personalização de funcionalidades.</p>

      <h4>3. Compartilhamento de Dados</h4>
      <p class="text-terms">Não compartilhamos os dados dos usuários com terceiros, exceto quando necessário para cumprir obrigações legais, responder a solicitações governamentais ou proteger nossos direitos e os direitos dos usuários.</p>

      <h4>4. Segurança dos Dados</h4>
      <p class="text-terms">Adotamos medidas de segurança, como criptografia de dados e controle de acesso restrito, para proteger as gravações e informações dos usuários contra acesso não autorizado.</p>

      <h4>5. Direitos do Usuário</h4>
      <p class="text-terms">Os usuários têm o direito de acessar, corrigir e excluir seus dados. Para exercer esses direitos, entre em contato conosco através do e-mail: contato@sanvault.com.br.</p>

      <h4>6. Cookies</h4>
      <p class="text-terms">Usamos cookies para melhorar a experiência de navegação e realizar análises. Os usuários podem configurar seu navegador para bloquear cookies, embora isso possa limitar algumas funcionalidades do sistema.</p>

      <h4>7. Alterações na Política</h4>
      <p class="text-terms">Podemos atualizar esta política periodicamente. Os usuários serão informados de qualquer mudança significativa e a política revisada será publicada em nosso site.</p>

      <h4>8. Contato</h4>
      <p class="text-terms">Para dúvidas sobre esta Política de Privacidade, entre em contato conosco em: contato@sanvault.com.br.</p>

    </div>
  </div>
</template>

<script>
export default {
  name: "TermsPage",
};
</script>